"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloseCaptionedEnum;
(function (CloseCaptionedEnum) {
    CloseCaptionedEnum["CLOSE_CAPTIONED"] = "Close captioned";
    CloseCaptionedEnum["NOT_REQUIRED"] = "Not required";
    CloseCaptionedEnum["WITHOUT_CC"] = "Video/audio without CC";
})(CloseCaptionedEnum = exports.CloseCaptionedEnum || (exports.CloseCaptionedEnum = {}));
var DateRangeText;
(function (DateRangeText) {
    DateRangeText["TO_BE_ANNOUNCED"] = "To be announced";
})(DateRangeText = exports.DateRangeText || (exports.DateRangeText = {}));
var StandingOrderEligible;
(function (StandingOrderEligible) {
    StandingOrderEligible["STANDING_NEW"] = "new";
    StandingOrderEligible["STANDING_REORDER"] = "recurrent";
    StandingOrderEligible["STANDING_DEFAULT"] = "default";
})(StandingOrderEligible = exports.StandingOrderEligible || (exports.StandingOrderEligible = {}));
var FreeTrials;
(function (FreeTrials) {
    FreeTrials["FREE_TRIAL"] = "free-trial";
    FreeTrials["FREE_TRIAL_FULL"] = "free-trial-full";
    FreeTrials["FULL"] = "full";
})(FreeTrials = exports.FreeTrials || (exports.FreeTrials = {}));
var PreviousSubscriptionType;
(function (PreviousSubscriptionType) {
    PreviousSubscriptionType["SUBSCRIBED_TO_FULL_PRODUCT"] = "subscribedToFullProduct";
    PreviousSubscriptionType["SUBSCRIBED_TO_FREE_TRIAL"] = "subscribedToFreeTrial";
    PreviousSubscriptionType["PURCHASED_FREE_TRIAL_IN_LAST_12MONTHS"] = "purchasedFreeTrialInLast12Months";
})(PreviousSubscriptionType = exports.PreviousSubscriptionType || (exports.PreviousSubscriptionType = {}));
var StandingOrderStatus;
(function (StandingOrderStatus) {
    StandingOrderStatus["ACTIVE"] = "Active";
    StandingOrderStatus["CANCELLED"] = "Cancelled";
    StandingOrderStatus["HISTORICAL"] = "Historical";
})(StandingOrderStatus = exports.StandingOrderStatus || (exports.StandingOrderStatus = {}));
var PriceMode;
(function (PriceMode) {
    PriceMode["EXTERNAL_PRICE"] = "ExternalPrice";
})(PriceMode = exports.PriceMode || (exports.PriceMode = {}));
//# sourceMappingURL=product-base.js.map